export const BUSINESS_SIGNUP_STATUS = {
    New: 'New',
    InProcess: 'In Process',
    Complete: 'Complete',
    Aborted: 'Aborted',
} as const;

export type BusinessSignupStatus =
    (typeof BUSINESS_SIGNUP_STATUS)[keyof typeof BUSINESS_SIGNUP_STATUS];

export const BOX_STATUS_TYPE = {
    Ready: 'Ready',
    Disabled: 'Disabled',
    Shipping: 'Shipping',
    NeedsRepair: 'Needs Repair',
    SetupNeeded: 'Setup Needed',
} as const;

export type BoxStatusType =
    (typeof BOX_STATUS_TYPE)[keyof typeof BOX_STATUS_TYPE];

export const BUSINESS_PICKUP_MODE = {
    // Legacy swipe-to-pickup — no NFC, no face verification.
    Swipe: 'Swipe',
    // NFC required to open cubby, no face verification.
    Nfc: 'Nfc',
    // NFC required + face verification on pickup.
    NfcWithFace: 'NfcWithFace',
} as const;

export type BusinessPickupMode =
    (typeof BUSINESS_PICKUP_MODE)[keyof typeof BUSINESS_PICKUP_MODE];
